<template>
  <div>
    <span
      class="iv-main-hover-color iv-main-color iv-pointer iv-operate-item iv-pull-left uit-editor-list iv-fs-14"
      @click="operateClick(item, 'see')"
    >{{'查看详情'}}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  inject: {
    operateClick: {
      default () {
        return () => {}
      }
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
</style>
